var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加线下收款数据",
            visible: _vm.dialogVisible,
            "append-to-body": true,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "lineP" }, [
            _c("p", { staticStyle: { "font-size": "18px" } }, [
              _vm._v("团号：" + _vm._s(_vm.$store.state.planId)),
            ]),
            _vm.addCollectionDetail.collection
              ? _c("p", { staticStyle: { "font-size": "18px" } }, [
                  _vm._v(
                    "确认单收款内容：" +
                      _vm._s(_vm.addCollectionDetail.collection.chargingContent)
                  ),
                ])
              : _vm._e(),
            _vm.addCollectionDetail.collection
              ? _c("p", { staticStyle: { "font-size": "18px" } }, [
                  _vm._v(
                    "确认单金额：" +
                      _vm._s(_vm.addCollectionDetail.collection.feeAmount)
                  ),
                ])
              : _vm._e(),
            _vm.showEditArr.indexOf("payDate") != -1
              ? _c(
                  "p",
                  [
                    _c("span", [_vm._v("客户付款时间：")]),
                    _c("el-date-picker", {
                      attrs: {
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        placeholder: "选择日期",
                      },
                      model: {
                        value: _vm.addCollectionDetail.payDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.addCollectionDetail, "payDate", $$v)
                        },
                        expression: "addCollectionDetail.payDate",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.showEditArr.indexOf("payName") != -1
              ? _c(
                  "p",
                  [
                    _c("span", [_vm._v("付款方名称：")]),
                    _c("el-autocomplete", {
                      attrs: { "fetch-suggestions": _vm.querySearchAsync },
                      on: { select: _vm.handleSelect },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function ({ item }) {
                              return [
                                _c("div", { staticClass: "name" }, [
                                  _vm._v(_vm._s(item.payName)),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4130473533
                      ),
                      model: {
                        value: _vm.addCollectionDetail.payName,
                        callback: function ($$v) {
                          _vm.$set(_vm.addCollectionDetail, "payName", $$v)
                        },
                        expression: "addCollectionDetail.payName",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.showEditArr.indexOf("payPrice") != -1
              ? _c(
                  "p",
                  [
                    _c("span", [_vm._v("收款金额：")]),
                    _c("el-input", {
                      model: {
                        value: _vm.addCollectionDetail.payPrice,
                        callback: function ($$v) {
                          _vm.$set(_vm.addCollectionDetail, "payPrice", $$v)
                        },
                        expression: "addCollectionDetail.payPrice",
                      },
                    }),
                    _vm._v(_vm._s(_vm.addCollectionDetail.currency)),
                  ],
                  1
                )
              : _vm._e(),
            _vm.showEditArr.indexOf("rate") != -1
              ? _c(
                  "p",
                  [
                    _c("span", [_vm._v("汇率：")]),
                    _c("el-input", {
                      model: {
                        value: _vm.addCollectionDetail.rate,
                        callback: function ($$v) {
                          _vm.$set(_vm.addCollectionDetail, "rate", $$v)
                        },
                        expression: "addCollectionDetail.rate",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.showEditArr.indexOf("remark") != -1
              ? _c(
                  "p",
                  [
                    _c("span", [_vm._v("备注：")]),
                    _c("el-input", {
                      model: {
                        value: _vm.addCollectionDetail.remark,
                        callback: function ($$v) {
                          _vm.$set(_vm.addCollectionDetail, "remark", $$v)
                        },
                        expression: "addCollectionDetail.remark",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.showEditArr.indexOf("file") != -1
              ? _c(
                  "div",
                  [
                    _vm.addCollectionDetail.waterVoucher &&
                    _vm.addCollectionDetail.waterVoucher != ""
                      ? _c("p", [
                          _c("span", [
                            _vm._v("已上传图片:"),
                            _c("img", {
                              attrs: {
                                src: _vm.addCollectionDetail.waterVoucher,
                              },
                            }),
                          ]),
                        ])
                      : _vm._e(),
                    _c("upload", {
                      ref: "upload",
                      staticStyle: { "margin-top": "0.1rem" },
                      attrs: { picLimit: 1 },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c("p", { staticStyle: { color: "red" } }, [
            _vm._v("注：请仔细核对你的信息是否正确，收款数据一旦确认无法更改"),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.sureAddUnderLineFlag },
                  on: { click: _vm.sureAddUnderLine },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }